import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ad77b838")

_pushScopeId("data-v-ad77b838")
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "big-text" }, " 広告主名や商品名など、わかりやすい名前を付けておくと管理しやすくなります ", -1)
const _hoisted_3 = { class: "commands" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_modal = _resolveComponent("modal")

  return (_openBlock(), _createBlock(_component_modal, {
    class: "edit-title",
    isShow: _ctx.isShow,
    "onUpdate:isShow": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShow = $event)),
    title: 
      _ctx.isSaveAs ? '作業ファイルを保存します' : '作業ファイル名を変更できます'
    ,
    isLeftTitle: true,
    isFitSize: true,
    onKeydown: _withKeys(_withModifiers(_ctx.setTitle, ["prevent"]), ["enter"])
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _withDirectives(_createVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.title = $event)),
          maxlength: _ctx.consts.maxEditTitleLength
        }, null, 8, ["maxlength"]), [
          [_vModelText, _ctx.title]
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("button", {
            class: "app-button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setTitle && _ctx.setTitle(...args)))
          }, [
            _createVNode("span", null, _toDisplayString(_ctx.isSaveAs ? "保存" : "決定"), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["isShow", "title", "onKeydown"]))
})